// extracted by mini-css-extract-plugin
module.exports = {"month":"Month_month__wD33q","monthName":"Month_monthName__3YnvL"};